import React, { useState } from 'react';

export default function HelpTooltip({ children }) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        className="help-tooltip-btn"
        onClick={() => setOpen(true)}
        title="Help"
      >
        ?
      </button>
      {open && (
        <div className="modal-overlay" onClick={() => setOpen(false)}>
          <div className="modal help-tooltip-modal" onClick={e => e.stopPropagation()}>
            <button className="help-tooltip-close" onClick={() => setOpen(false)}>&times;</button>
            <div className="help-tooltip-content">
              {children}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
